import { render } from "./AnimatedLogo.vue?vue&type=template&id=596bced6&scoped=true"
import script from "./AnimatedLogo.vue?vue&type=script&lang=js"
export * from "./AnimatedLogo.vue?vue&type=script&lang=js"

import "./AnimatedLogo.vue?vue&type=style&index=0&id=596bced6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596bced6"]])

export default __exports__